import { IAccountDetailsStore } from 'account/accountDetailsStore';
import { Col, Modal, Select, Space } from 'antd';
import { Field, Formik, FormikProps } from 'formik';
import { FFieldLabel, FInput } from 'forms/FormikFormItems';
import { ajaxCatch } from 'helper/api';
import { useRootData } from 'hooks/hook';
import { CenteredRow } from 'layout/CenteredRow';
import { showErrorModal } from 'layout/Modals';
import React, { useEffect, useRef, useState } from 'react';
import { getProfiBazaApiClient } from 'services/ProfiBazaApi';
import { ContactDto, SubjectContactDto } from 'services/src/models';
import { ProfiBazaAPIModels } from 'services/src/profiBazaAPI';

import { SubjectCommentArea } from '../comments/SubjectCommentArea';
import { SubjectCommentIcon } from '../comments/SubjectCommentIcon';
import { SubjectContactValidationSchema } from '../Validators/SubjectContactValidation';

interface IProps {
	visible: boolean;
	editable?: boolean;
	data?: ContactDto;
	onCreate: (values: any) => void;
	onChange: (values: any) => void;
	onCancel: () => void;
	selectFromList?: boolean;
	checkDuplicates: (contact: any) => boolean;
}
const SubjectContactModal: React.FC<IProps> = (props) => {
	const {
		visible,
		onCancel,
		onCreate,
		onChange,
		data,
		selectFromList,
	} = props;

	const formikRef = useRef<Formik<ContactDto>>(null);
	const [contacts, setContacts] = useState<SubjectContactDto[]>();
	const [contact, setContact] = useState<ContactDto | undefined>(data);

	const accountDetailsStore: IAccountDetailsStore = useRootData(
		(store) => store.accountDetailsStore
	);

	useEffect(() => {
		setContact(data);
	}, [data]);

	useEffect(() => {
		if (!props.editable || !selectFromList) return;

		if (accountDetailsStore.account.get()?.subject?.id) {
			ajaxCatch(() =>
				getProfiBazaApiClient()
					.then((api) =>
						api.contact.getById(
							accountDetailsStore.account.get()?.subject?.id!
						)
					)
					.then((contacts: ProfiBazaAPIModels.ContactDto[]) => {
						setContacts(contacts);
					})
			);
		}
	}, [accountDetailsStore.account.get()?.subject?.id!]);

	return (
		<>
			<Formik
				validateOnChange={false}
				validateOnBlur={true}
				initialValues={contact || {}}
				enableReinitialize={true}
				ref={formikRef}
				validationSchema={SubjectContactValidationSchema}
				onSubmit={(values, actions) => {

					if (props.checkDuplicates(values)) {
						showErrorModal(
							'Kontakt z takimi danymi został już dodany.'
						);
						return;
					}

					if (props.data) {
						onChange(values);
					} else {
						onCreate(values);
					}
					actions.resetForm();
				}}
				render={(props: FormikProps<any>) => (
					<Modal
						visible={visible}
						maskClosable={false}
						centered
						title={data ? 'Edycja kontaktu' : 'Dodawanie kontaktu'}
						onOk={() => {
							props.submitForm();
						}}
						onCancel={() => {
							onCancel();
							formikRef.current?.resetForm();
						}}
						okText="Zatwierdź"
					>
						{selectFromList && (
							<CenteredRow>
								<Col span={20}>
									<FFieldLabel
										label="Wybierz z RP"
										for="contact"
									/>
									<Select
										placeholder="Wybierz"
										id="contact"
										value={
											contact
												? `${contact?.firstName} ${contact?.lastName}`
												: undefined
										}
										onChange={(value: string) => {
											setContact(
												contacts?.find(
													(x) => x.id == value
												)
											);
										}}
									>
										{contacts?.map(
											(
												element: ContactDto,
												index: number
											) => {
												return (
													<Select.Option
														key={index}
														value={element.id!}
													>{`${element.firstName} ${element.lastName}`}</Select.Option>
												);
											}
										)}
									</Select>
								</Col>
							</CenteredRow>
						)}
						<CenteredRow>
							<Col span={20}>
								<Space>
									<FFieldLabel label="Imię" for="firstName" />
									<SubjectCommentIcon fieldName="firstName" />
								</Space>
								<SubjectCommentArea fieldName="firstName">
									<Field
										component={FInput}
										name="firstName"
									/>
								</SubjectCommentArea>
							</Col>
						</CenteredRow>
						<CenteredRow>
							<Col span={20}>
								<Space>
									<FFieldLabel
										label="Nazwisko"
										for="lastName"
									/>
									<SubjectCommentIcon fieldName="lastName" />
								</Space>
								<SubjectCommentArea fieldName="lastName">
									<Field component={FInput} name="lastName" />
								</SubjectCommentArea>
							</Col>
						</CenteredRow>
						<CenteredRow>
							<Col span={20}>
								<Space>
									<FFieldLabel
										label="Stanowisko"
										for="position"
									/>
									<SubjectCommentIcon fieldName="position" />
								</Space>
								<SubjectCommentArea fieldName="position">
									<Field component={FInput} name="position" />
								</SubjectCommentArea>
							</Col>
						</CenteredRow>
						<CenteredRow>
							<Col span={20}>
								<Space>
									<FFieldLabel label="E-mail" for="email" />
									<SubjectCommentIcon fieldName="email" />
								</Space>
								<SubjectCommentArea fieldName="email">
									<Field component={FInput} name="email" />
								</SubjectCommentArea>
							</Col>
						</CenteredRow>
						<CenteredRow>
							<Col span={20}>
								<Space>
									<FFieldLabel
										label="Telefon"
										for="phoneNumber"
									/>
									<SubjectCommentIcon fieldName="phoneNumber" />
								</Space>
								<SubjectCommentArea fieldName="phoneNumber">
									<Field
										component={FInput}
										name="phoneNumber"
									/>
								</SubjectCommentArea>
							</Col>
						</CenteredRow>
					</Modal>
				)}
			/>
		</>
	);
};
export default SubjectContactModal;
